import { useCanAccess } from 'react-admin';

export function useBillingItemPrefetch() {
  const { canAccess: canAccessMerchants } = useCanAccess({
    resource: 'merchants',
    action: 'list',
  });
  const { canAccess: canAccessPaymentTypes } = useCanAccess({
    resource: 'billing_item_payment_types',
    action: 'list',
  });
  const { canAccess: canAccessBillingItemStatuses } = useCanAccess({
    resource: 'billing_item_statuses',
    action: 'list',
  });
  const { canAccess: canAccessRegions } = useCanAccess({ resource: 'regions', action: 'list' });

  const prefetch: string[] = [];
  if (canAccessMerchants) prefetch.push('merchant');
  if (canAccessMerchants && canAccessRegions) prefetch.push('merchant.region');
  if (canAccessPaymentTypes) prefetch.push('billing_item_payment_type');
  if (canAccessBillingItemStatuses) prefetch.push('billing_item_status');

  return prefetch;
}

export function useMerchantPrefetch() {
  const { canAccess: canAccessRegions } = useCanAccess({ resource: 'regions', action: 'list' });

  return canAccessRegions ? ['region'] : [];
}
